import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { isArray } from 'lodash-es';
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
const filter = createFilterOptions();

const TextFieldAutoCompleteFree = ({
  control,
  name,
  label,
  defaultValue,
  disabled,
  rules,
  hidden,

  error,
  options,
  optionSelected,
  onChange
}) => {
  const classesTablero = useStylesTablero();
  const formatoOpcion = newValue => {
    //es nueva opcion si
    if (typeof newValue === 'string' || (newValue && newValue.inputValue)) {
      let seleccionado = null;
      // si la pcion cambior enter
      if (typeof newValue === 'string') {
        seleccionado = {
          [optionSelected.label]: newValue.trim()
        };
      } else {
        // si la opcion cambio por click y es nuevo
        seleccionado = {
          [optionSelected.label]: newValue.inputValue.trim()
        };
      }
      //ultima busqueda
      return (
        options.find(
          opc => opc[optionSelected.label] == seleccionado[optionSelected.label]
        ) || seleccionado
      );
    } else {
      //valor ya registrado
      return newValue;
    }
  };
  const onChangep = setValue => (event, newValue) => {
    if (isArray(newValue))
      setValue(newValue.map(option => formatoOpcion(option)));
    else {
      setValue(formatoOpcion(newValue));
    }
  };
  const opcionesFiltradas = (options, params) => {
    const filtered = filter(options, params);
    // agrega la occion de nuevo
    if (
      params.inputValue !== '' &&
      !options.find(
        opt =>
          params.inputValue.toLowerCase() ==
          opt[optionSelected.label].toLowerCase()
      )
    ) {
      filtered.push({
        inputValue: params.inputValue,
        [optionSelected.label]: `Agregar "${params.inputValue}"`
      });
    }
    return filtered;
  };
  const getOptionLabel = option =>
    typeof option === 'string'
      ? option
      : option.inputValue || option[optionSelected.label];
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || null}
      render={props2 => (
        <Autocomplete
          value={props2.value}
          onChange={
             onChangep(onChange?(value)=>{
               props2.onChange(value);
               onChange(value);
             }:props2.onChange)}
          size="small"
          fullWidth
          options={options || []}
          
          defaultValue={defaultValue || null}
          getOptionSelected={(option, value) =>
            value == undefined ||
            value === '' ||
            option[optionSelected.id] === value[optionSelected.id]
          }
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label={label}
              error={Boolean(error)}
              hidden={hidden}
              helperText={error}
              className={classesTablero.field}
            />
          )}
          getOptionLabel={getOptionLabel}
          multiple={isArray(defaultValue)}
          disabled={disabled}
          noOptionsText="No hay coincidencias"
          filterOptions={opcionesFiltradas}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          freeSolo
          renderOption={option => option[optionSelected.label]}
        />
      )}
    />
  );
};
TextFieldAutoCompleteFree.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.object,
  rules: PropTypes.object.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  onchange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  optionSelected: PropTypes.shape({
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  })
};

TextFieldAutoCompleteFree.defaultProps = {
  label: '',
  defaultValue: null,
  optionSelected: { id: 'default', label: 'default' }
};

export default TextFieldAutoCompleteFree;
